import { Svg } from 'components'
import loadingIcon from 'assets/loading.svg'

const styles = {
  initial: ['rounded', 'relative'],
  size: {
    md: ['py-2', 'px-4'],
    sm: ['py-1', 'px-4', 'text-sm'],
    'sm-square': ['py-1', 'px-1', 'text-sm'],
    'md-square': ['py-2', 'px-2', 'text-md']
  },
  variant: {
    plain: ['bg-gray-500', 'hover:bg-gray-600', 'text-white', 'font-bold'],
    positive: ['bg-green-600', 'hover:bg-green-500', 'text-white', 'border-green-700', 'hover:border-green-500'],
    info: ['bg-blue-500', 'hover:bg-blue-400', 'text-white', 'border-blue-700', 'hover:border-blue-500'],
    warning: ['bg-orange-500', 'hover:bg-orange-400', 'text-white', 'border-orange-700', 'hover:border-orange-500'],
    danger: ['bg-red-800', 'hover:bg-red-800', 'text-white', 'hover:text-gray-800', 'border-red-800', 'hover:border-red-800', 'border-2'],
    circle: ['rounded-full', 'h-12', 'w-12', 'shadow-lg', 'bg-blue-500', 'text-white', 'flex', 'justify-center', 'items-center'],
    spin: ['bg-transparent', 'hover:bg-gray-900', 'text-gray-800']
  }
}

const loadingSpinner = () => {
  return m(Svg, {
    classes: ['w-6', 'text-white', 'rotate', 'm-auto']
  }, loadingIcon)
}

export const Button = () => {
  return {
    view ({
      children,
      attrs: {
        href,
        size = 'md',
        variant = 'info',
        block = false,
        onclick = () => {},
        classes = [],
        loading,
        icon,
        type = 'submit'
      }
    }) {
      const tag = href ? m.route.Link : 'button'
      return m(tag, {
        href,
        onclick,
        type,
        class: [
          block ? 'w-full' : '',
          loading ? 'pointer-events-none' : '',
          ...styles.initial,
          ...styles.size[size],
          ...styles.variant[variant],
          ...classes
        ].join(' ')
      }, [
        m('span.flex.gap-2.items-center.justify-center', {
          class: loading ? 'opacity-0' : ''
        }, [
          icon && m(Svg, { classes: [size === 'xs' ? 'h-4' : size === 'sm' ? 'h-5' : 'h-6'] }, icon),
          children
        ]),
        loading &&
        m('.absolute-center', loadingSpinner())
      ])
    }
  }
}
